import React, { Component } from "react";
import { Grid, Row, Col, Table, FormGroup } from "react-bootstrap";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import Card from "components/Card/Card.jsx";
import { WEB_URL } from "variables/Variables.jsx";
import Datetime from "react-datetime";
import moment from "moment";
import { ExportToCsv } from 'export-to-csv';
import Button from "components/CustomButton/CustomButton.jsx";

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

class Leads extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      leadsList : null,
      dateStart: moment().subtract(1, 'months'),
      dateEnd: moment(),
      runningSearch : false,
      runningDeleteLead : false,
      runningDeleteAllLeads : false
    }
  }

  componentDidMount () {
    this.fetchLeads();
  }

  setDateStart(d){
    this.setState({dateStart : d});
  }

  setDateEnd(d){
    this.setState({dateEnd : d});
  }  

  fetchLeads(){
    this.setState({runningSearch : true});

    fetch("https://"+WEB_URL+"/account/api/leads",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&detail=true',
      body: JSON.stringify({token : this.props.authDetail.token, checksum : this.props.authDetail.checksum, detail : true, publication : this.props.match.params.publication, searchDateFrom : this.state.dateStart.toISOString(), searchDateTo : this.state.dateEnd.toISOString()})
    }).then(res => res.json())
      .then(
        (response) => {
          if(response.Error == "Authentication Failed"){
            this.props.setLoggedIn(false);    
            return;
          }

          var dl = [];
          for(var p=0;p<response.leads.length;p++){
              dl.push(response.leads[p]);
          }
          this.setState({leadsList : dl})
          this.setState({runningSearch : false});
        },
        (error) => {
          this.setState({runningSearch : false});
        }
      )
  }

  csvExport(){
    const options = { 
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true, 
      showTitle: true,
      title: 'Leads for ' + this.props.match.params.publication,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    };

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(this.state.leadsList);
  }

  deleteAllLeads(){
    if(window.confirm('Are you sure you want to delete all leads for this publication?')){
        this.setState({runningDeleteAllLeads : true});

        fetch("https://"+WEB_URL+"/account/api/leads",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&identifier='+publication[0]
        'body' : JSON.stringify({'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'action':'deleteAllLeads','publication':this.props.match.params.publication})
      }).then(res => res.json())
        .then(
          (response) => {
            this.setState({runningDeleteAllLeads : false});
            if(response.result == 'SUCCESS'){
              this.props.triggerNotification('success','tc',response.message);
              this.fetchLeads();
            }else{
              this.props.triggerNotification('error','tc',response.message);  
              this.setState({runningDeleteCloudPublication : false});
            }
          },
          (error) => {
            this.props.triggerNotification('error','tc','Error deleting the leads. Please try again in a little while.');
            this.setState({runningDeleteAllLeads : false});
          }
        )
    }  
  }

  deleteLead(lead){
    if(window.confirm('Are you sure you want to delete this entry?')){
      this.setState({runningDeleteLead : lead});

      fetch("https://"+WEB_URL+"/account/api/leads",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&identifier='+publication[0]
        'body' : JSON.stringify({'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'action':'deleteLead','identifier':lead.id})
      }).then(res => res.json())
        .then(
          (response) => {
            if(response.result == 'SUCCESS'){
              this.props.triggerNotification('success','tc',response.message);
              this.fetchLeads();
              this.setState({runningDeleteLead : false});
            }else{
              this.props.triggerNotification('error','tc',response.message);  
              this.fetchLeads();
              this.setState({runningDeleteLead : false});
            }
          },
          (error) => {
            this.props.triggerNotification('error','tc','Error deleting the entry. Please try again in a little while.');
            this.fetchLeads();
            this.setState({runningDeleteLead : false});
          }
        )
    }
  }

  getCloudLink(publication){
    if(this.props.authDetail.detail.cloudId && this.props.authDetail.detail.cloudId != this.props.authDetail.user){
      return "https://"+this.props.authDetail.detail.cloudId+".flowpaper.com/"+publication+"/";
    }else{
      return "https://online.flowpaper.com/"+this.props.authDetail.user+"/"+publication+"/";
    }
  }

  goBack(){
    this.props.history.push('/home/cloud/'); 
  }

  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={10}>
              <ProgressButton bsStyle="default btn-wd btn btn-sm" fill type="submit" onClick={(e) => {this.goBack(e);}}><i class="pe-7s-back"></i> Go Back</ProgressButton>
              <h4 style={{'margin-top':20}}><b>Publication</b>: <a target="_new" href={this.getCloudLink(this.props.match.params.publication)}>{this.getCloudLink(this.props.match.params.publication)}</a></h4>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <FormGroup>
                <label class="control-label">Date From</label>
                <Datetime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  inputProps={{ placeholder: "Datetime Picker Here" }}
                  defaultValue={this.state.dateStart}
                  onChange={(d) => this.setDateStart(d)}
                />
               </FormGroup>
             </Col>
             <Col md={2}>
              <FormGroup>
                <label class="control-label">Date To</label>
                <Datetime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  inputProps={{ placeholder: "Datetime Picker Here" }}
                  defaultValue={this.state.dateEnd}
                  onChange={(d) => this.setDateEnd(d)}
                />
               </FormGroup>
             </Col>      
             <Col md={6}>
              <FormGroup>
                <label style={{visibility:'hidden',display:'block'}} class="control-label">---</label>
                <ProgressButton runningAsyncOperation={this.state.runningSearch} bsStyle="info" fill type="submit" onClick={(e) => {this.fetchLeads(e);}}>
                    Search
                </ProgressButton>
                <ProgressButton runningAsyncOperation={this.state.exportingCSV} bsStyle="info" fill type="submit" onClick={(e) => {this.csvExport(e);}} style={{'margin-left':'10px'}}>
                    Export to CSV
                </ProgressButton>
                <ProgressButton runningAsyncOperation={this.state.runningDeleteAllLeads} bsStyle="danger pull-right" fill type="submit" onClick={(e) => {this.deleteAllLeads(e);}}>
                      Delete All
                  </ProgressButton>
              </FormGroup>
             </Col>       
          </Row>
          {this.state.leadsList!=null ? 
          <Row>
            <Col md={10}>
            {this.state.leadsList.length ? 
            <Card
                title=""
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th>Contact Info</th>
                        <th>Left Email</th>
                        <th>Views</th>
                        <th className="pull-right">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                    {this.state.leadsList.map((lead, index) => {
                      
                        return (
                            <tr key={`${lead.id}`}>
                                <td>{lead.email} {lead.name && lead.name.length?'('+lead.name+')':''}</td>
                                <td>{new Date(lead.created_at).toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</td>
                                <td>{lead.views}</td>
                                <td>
                                <ProgressButton style={{'min-height':'28px','min-width':'77px'}} runningAsyncOperation={this.state.runningDeleteLead == lead} bsStyle="danger pull-right btn-xs" fill type="submit" onClick={(e) => {this.deleteLead(lead,e);}}>
                                Delete Entry
                                </ProgressButton>
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                  </Table>
                }
              />:<Card
              title=""
              category=""
              ctTableFullWidth
              ctTableResponsive
              content={
                <div style={{margin:20}}>No available leads for this publication in the selected period</div>
              }/>}
            </Col>
          </Row>
          :<div className="spinner-grow text-primary" role="status">
          <span className="sr-only">Loading...</span>
          </div>}
        </Grid>
      </div>
    );
  }
}

export default Leads;
